import { t } from "i18next";
export function getMeterTableErrorText(errorKey: string) {
  return t(`errors.SiteSetupAssistant.MeterTable.${errorKey}`);
}
